/**
 * AnyDesk เป็นของ "เครื่อง" — เปลี่ยน/ถอดเครื่องของแถวรายการเช่าแล้ว ค่าเดิมไม่ใช่ของเครื่องใหม่
 * → ล้างช่อง AnyDesk ให้ (mirror backend: PUT /rentals ที่สลับเครื่องในแถวเดิมล้าง anydesk_id · 23 ก.ย. 2026)
 *
 * ใช้ในฟอร์มแก้ไขการเช่า (RentalEditPageV2.updateRentalItem) · คืนแถวใหม่ (ไม่แก้ของเดิม)
 * `_anydesk_cleared` = ธง UI ให้แสดงข้อความใต้ช่อง (ไม่ส่งไป backend)
 */
export interface AnydeskSwapRow {
  device_id: number | '' | null | undefined;
  anydesk_id?: string | null;
  _anydesk_cleared?: boolean;
}

export function applyAnydeskResetOnDeviceChange<T extends AnydeskSwapRow>(
  prev: T | undefined,
  next: T,
  field: string,
): T {
  if (field === 'anydesk_id') {
    return next._anydesk_cleared ? { ...next, _anydesk_cleared: false } : next;
  }
  const prevDevice = prev?.device_id ?? '';
  const nextDevice = next.device_id ?? '';
  if (prevDevice !== nextDevice && (next.anydesk_id || '').trim()) {
    return { ...next, anydesk_id: '', _anydesk_cleared: true };
  }
  return next;
}
